/** @format */

const surnames = [
  'abba',
  'abeltino',
  'abis',
  'abruzzo',
  'acalai',
  'accalai',
  'accardo',
  'acciaro',
  'acerbis',
  'achenza',
  'acquas',
  'acquaviva',
  'acri',
  'adamo',
  'addari',
  'addis',
  'africano',
  'agnelli',
  'agus',
  'aiana',
  'aiello',
  'airi',
  'aisoni',
  'alasia',
  'alba',
  'albai',
  'albanese',
  'albertazzi',
  'alberti',
  'albino',
  'aledda',
  'alesi',
  'alfieri',
  'alicicco',
  'alivia',
  'allegria',
  'allieri',
  'almiento',
  'altamira',
  'altamura',
  'altea',
  'alvau',
  'alzu',
  'amabile',
  'amadasi',
  'amaranto',
  'amatiello',
  'ambrosini',
  'ambu',
  'ambus',
  'amendola',
  'amenta',
  'amicarelli',
  'amico',
  'ammirata',
  'amore',
  'amorino',
  'amuganu',
  'anchisi',
  'andreoli',
  'andreotti',
  'andreozzi',
  'anedda',
  'aneris',
  'angei',
  'angelini',
  'angelucci',
  'angileri',
  'angioi',
  'angioj',
  'angiolini',
  'angioni',
  'angioy',
  'angius',
  'angotzi',
  'annese',
  'annibale',
  'annibali',
  'annis',
  'anolfo',
  'antonacci',
  'antoni',
  'antoniotti',
  'anziani',
  'apeddu',
  'apicella',
  'apogeo',
  'appeddu',
  'ara',
  'aracu',
  'aragona',
  'aragonese',
  'aramini',
  'aramu',
  'arangino',
  'arba',
  'arbau',
  'arberi',
  'arca',
  'arcadu',
  'arceri',
  'arcidiacono',
  'ardau',
  'ardu',
  'are',
  'aresti',
  'aresu',
  'aretino',
  'arghittu',
  'arghitu',
  'argilla',
  'argiola',
  'argiolas',
  'argiolu',
  'ari',
  'ariu',
  'arrais',
  'arras',
  'arrica',
  'arricca',
  'arrigoni',
  'arru',
  'arrus',
  'artitzu',
  'artizzu',
  'aru',
  'arus',
  'arzu',
  'asara',
  'asquer',
  'assaretti',
  'astara',
  'aste',
  'asteghene',
  'astero',
  'asuni',
  'asunis',
  'atanasio',
  'attanasio',
  'attene',
  'atzei',
  'atzeni',
  'atzenis',
  'atzeri',
  'atzori',
  'auci',
  'augias',
  'auriemma',
  'avagnina',
  'aversano',
  'azara',
  'azzeni',
  'azzu',
  'bacchiddu',
  'bacciu',
  'baccoli',
  'bachiddu',
  'bachis',
  'badalamenti',
  'baffigo',
  'bagedda',
  'bagella',
  'bagnolo',
  'baiocchi',
  'baire',
  'balata',
  'balbi',
  'balbina',
  'baldan',
  'baldelli',
  'baldini',
  'baldino',
  'baldinu',
  'baldo',
  'balduzzi',
  'baledda',
  'balia',
  'ballarin',
  'balletto',
  'ballisai',
  'ballocco',
  'balloco',
  'balloi',
  'ballore',
  'baltolu',
  'balvis',
  'balzani',
  'balzano',
  'bandini',
  'bandino',
  'bandinu',
  'barabino',
  'baraglia',
  'baragone',
  'barale',
  'barba',
  'barbara',
  'barbaro',
  'barbarossa',
  'barberio',
  'barbero',
  'barbieri',
  'barca',
  'barcella',
  'bardi',
  'barison',
  'barnaba',
  'barone',
  'baroni',
  'barra',
  'barracca',
  'barraccu',
  'barracu',
  'barrago',
  'barranca',
  'barranu',
  'barria',
  'barrocu',
  'barroi',
  'barrottu',
  'basciu',
  'basilico',
  'baso',
  'basoccu',
  'basocu',
  'basolu',
  'bassi',
  'basso',
  'bassu',
  'batista',
  'battaglia',
  'battaglini',
  'battista',
  'battistoni',
  'battuello',
  'batzella',
  'bayslak',
  'bazzoni',
  'bazzu',
  'becciu',
  'beccu',
  'bechere',
  'belgiorno',
  'bellis',
  'bellisai',
  'bello',
  'belloni',
  'bellu',
  'bellucci',
  'belotti',
  'beltrami',
  'berardi',
  'beretta',
  'bergamaschi',
  'berlinguer',
  'bernacchia',
  'bernardini',
  'bertacchini',
  'bertani',
  'bertelli',
  'bertini',
  'bertocchi',
  'bertoldi',
  'bertoletti',
  'bertucci',
  'bertulu',
  'berutti',
  'besalduch',
  'bettelli',
  'bevilacqua',
  'biagioni',
  'biancacci',
  'biancareddu',
  'bianchi',
  'bianco',
  'biancu',
  'biccheddu',
  'biddau',
  'biddoccu',
  'bidoni',
  'bifulco',
  'biggio',
  'bigolin',
  'bindi',
  'bindinelli',
  'biosa',
  'biscu',
  'bissiri',
  'bistrussu',
  'bitti',
  'bittichesu',
  'blasi',
  'bo',
  'boccaletti',
  'bocco',
  'boe',
  'boeddu',
  'boeri',
  'boero',
  'boi',
  'bois',
  'boldrin',
  'bolla',
  'bollas',
  'bolliri',
  'bombagi',
  'bomboi',
  'bonafede',
  'bonato',
  'boneddu',
  'bonesu',
  'bonfant',
  'bongiovanni',
  'bono',
  'bonomo',
  'bonu',
  'bonucci',
  'borgatti',
  'borio',
  'borsani',
  'borto',
  'bortolotti',
  'bortolu',
  'borzoni',
  'bosa',
  'boscani',
  'bosilo',
  'bosio',
  'bosu',
  'botta',
  'bottaru',
  'botti',
  'bottino',
  'bottone',
  'boy',
  'boyl',
  'bozzetto',
  'bracco',
  'brai',
  'braina',
  'brambilla',
  'branca',
  'branchitta',
  'brandano',
  'brandanu',
  'brandas',
  'brandino',
  'brandinu',
  'brasile',
  'bratzu',
  'brau',
  'bravi',
  'brenna',
  'bressan',
  'brigas',
  'brocca',
  'broi',
  'bronzini',
  'brotzu',
  'brovelli',
  'brozzu',
  'brugnettini',
  'brundu',
  'brunetti',
  'bruno',
  'bua',
  'buccelli',
  'bucciarelli',
  'buccieri',
  'buccoli',
  'buccudu',
  'bucino',
  'budroni',
  'buggiu',
  'buiaroni',
  'bulciolu',
  'bulla',
  'bullita',
  'buluggiu',
  'buongiorno',
  'buratti',
  'burrai',
  'burreddu',
  'burruni',
  'busacchi',
  'busanca',
  'buscarino',
  'buschettu',
  'buseddu',
  'busi',
  'busia',
  'bussa',
  'bussi',
  'bussu',
  'buttau',
  'buttiglione',
  'buttu',
  'cabboi',
  'cabiddu',
  'cabitza',
  'cabizzosu',
  'caboi',
  'caboni',
  'cabras',
  'cabriolu',
  'cabua',
  'caburosso',
  'caburrosso',
  'cacciarru',
  'cacciotto',
  'cacciuto',
  'cadau',
  'caddeo',
  'caddori',
  'cadeddu',
  'cadelano',
  'cadinu',
  'cadoni',
  'cafarelli',
  'caggiari',
  'calabrese',
  'calaresu',
  'caldaras',
  'calia',
  'calledda',
  'calori',
  'caltabellotta',
  'calvia',
  'calvisi',
  'calzaghe',
  'calzone',
  'camatel',
  'camba',
  'cambedda',
  'cambilargiu',
  'camboni',
  'cambosu',
  'cambula',
  'cambuli',
  'camedda',
  'camilleri',
  'camoglio',
  'campa',
  'campagnola',
  'campana',
  'campanile',
  'campedelli',
  'campesi',
  'campione',
  'campisi',
  'campo',
  'campolongo',
  'camporesi',
  'campurra',
  'campus',
  'canalis',
  'canavera',
  'cancedda',
  'canelles',
  'canepa',
  'cani',
  'cannaos',
  'cannas',
  'cannavaro',
  'cansella',
  'cantone',
  'canu',
  'cao',
  'cau',
  'caocci',
  'caone',
  'capai',
  'capalbo',
  'capasso',
  'capelli',
  'capicciola',
  'capitta',
  'capone',
  'cappai',
  'cappelli',
  'cappellini',
  'cappicciola',
  'cappiello',
  'capra',
  'caprioli',
  'capussotti',
  'capuzzi',
  'cara',
  'caracoi',
  'carai',
  'carassino',
  'caratzu',
  'carau',
  'caravagna',
  'carbini',
  'carbone',
  'carboni',
  'carcangiu',
  'cardella',
  'cardenia',
  'cardi',
  'cardia',
  'cardinale',
  'cardone',
  'caredda',
  'careddu',
  'carelli',
  'caria',
  'carlini',
  'carlino',
  'carlodalatri',
  'carlotti',
  'carminati',
  'caron',
  'carraca',
  'carracoi',
  'carrau',
  'carreras',
  'carro',
  'carrogu',
  'carrone',
  'carru',
  'carrucciu',
  'carrus',
  'carrusci',
  'carta',
  'cartamantiglia',
  'cartamantiglia',
  'carucci',
  'carulli',
  'carvone',
  'carzedda',
  'casablanca',
  'casacca',
  'casadei',
  'casano',
  'casanova',
  'casari',
  'casarin',
  'casas',
  'casati',
  'caschili',
  'casciu',
  'casedda',
  'casiddu',
  'cassano',
  'casta',
  'castagna',
  'castagnoli',
  'castaldi',
  'castangia',
  'castellaneta',
  'castellano',
  'castelli',
  'casti',
  'casu',
  'casula',
  'casule',
  'catalano',
  'catania',
  'catapano',
  'catgiu',
  'catta',
  'cattanei',
  'cattaneo',
  'catte',
  'cattini',
  'cattolico',
  'cau',
  'caula',
  'cauli',
  'cavada',
  'cavallaro',
  'cavalleri',
  'cavallini',
  'cavallo',
  'cavanna',
  'cavia',
  'caviglia',
  'cavoli',
  'cazzaniga',
  'cazzeddu',
  'cazzona',
  'cecaro',
  'ceccarelli',
  'celestini',
  'celli',
  'cellino',
  'censi',
  'cera',
  'cerbello',
  'cerioni',
  'cerniglia',
  'cerra',
  'cerrato',
  'cerronis',
  'cervo',
  'cesana',
  'cesaro',
  "cesaro'",
  'ceselia',
  'chelo',
  'cherchi',
  'cheri',
  'chessa',
  'chia',
  'chiappe',
  'chiappori',
  'chiaramida',
  'chighine',
  'chighini',
  'chillotti',
  'chiocca',
  'chironi',
  'chirra',
  'chiscuzzu',
  'ciabattini',
  'ciaccia',
  'ciaddu',
  'ciampi',
  'cianchetti',
  "cicalo'",
  'ciccu',
  'cicerchia',
  'cichi',
  'cicilloni',
  'cicu',
  'cilia',
  'cilla',
  "cimo'",
  'cinatempo',
  'cincotti',
  'cinellu',
  'cinus',
  'cioffi',
  'cioncia',
  'cioni',
  'ciosci',
  'cipolla',
  'cipollina',
  'cipriani',
  'circu',
  'cireddu',
  'cirina',
  'cirino',
  'cirri',
  'cittadini',
  'ciucci',
  'ciudino',
  'climan',
  'clinco',
  'clivio',
  'cocciu',
  'cocco',
  'coccollone',
  'coccone',
  'coco',
  'coda',
  'codonesu',
  'coghe',
  'cogoni',
  'cogotti',
  'coi',
  'coiana',
  'coinu',
  'cois',
  'coizza',
  'cojana',
  'cola',
  'coletta',
  'colla',
  'colleo',
  'collu',
  'colombi',
  'colombino',
  'colombo',
  'colomo',
  'colosimo',
  'columbu',
  'comida',
  'comparetti',
  'conca',
  'concas',
  'conchedda',
  'conconi',
  'concu',
  'condorelli',
  'conedda',
  'congia',
  'congias',
  'congiu',
  'congiunti',
  'consoli',
  'conte',
  'conteddu',
  'conti',
  'contine',
  'contini',
  'contino',
  'contis',
  'contu',
  'copez',
  'coppini',
  'coppola',
  'coraddu',
  'coradduzza',
  'coraduzza',
  'corazza',
  'corbeddu',
  'corbia',
  'corbu',
  'corchia',
  'corda',
  'cordedda',
  'corellas',
  'corgiolu',
  'corizia',
  'corona',
  'coronas',
  'corongiu',
  'corpino',
  'corraine',
  'correddu',
  'corria',
  'corrias',
  'corriga',
  "corro'",
  'corronca',
  'corsale',
  'corsi',
  'corso',
  'cortese',
  'cortis',
  'corveddu',
  'cosa',
  'cosentino',
  'cossa',
  'cosseddu',
  'cossiga',
  'cosso',
  'cossu',
  'costa',
  'costaggiu',
  'costantini',
  'cotrino',
  'cottiglia',
  'cottu',
  'cotza',
  'cotzia',
  'covelli',
  'cozza',
  'cozzolino',
  'cozzula',
  'crabu',
  'crasta',
  'crastu',
  'cravero',
  'crespellani',
  'crippa',
  'crispatzu',
  'crisponi',
  'crispu',
  'cristaldi',
  'croba',
  'crobeddu',
  'crobu',
  'crotta',
  'crovetti',
  'crucas',
  'cruccas',
  'cruccu',
  'cruciani',
  'cualbu',
  'cubeddu',
  'cucca',
  'cuccheddu',
  'cucchi',
  'cuccia',
  'cucciari',
  'cuccu',
  'cuccui',
  'cucculliu',
  'cuccureddu',
  'cuccuru',
  'cucureddu',
  'cucurru',
  'cudrano',
  'cugia',
  'cugini',
  'cugudda',
  'cugusi',
  'cui',
  'culeddu',
  'culiolo',
  'culmone',
  'culurgioni',
  'cumpostu',
  'cuozzo',
  'curcio',
  'curcu',
  'curreli',
  "curro'",
  'cuscusa',
  'cusini',
  'cusseddu',
  'cutaia',
  'cuttaia',
  'cuzzocrea',
  "d'accardi",
  "d'achille",
  'daddi',
  'dadone',
  'daga',
  "d'agostino",
  'dalpadullo',
  "d'alfonso",
  'dalmonte',
  'dalpadulo',
  'dalu',
  "d'amato",
  "d'amico",
  "d'amore",
  'danese',
  "d'angelo",
  "d'auria",
  'davi',
  'deagostini',
  'deamicis',
  'debellis',
  'debiase',
  'debidda',
  'decarlo',
  'decherchi',
  'decortes',
  'defanti',
  'defilippi',
  'degaetano',
  'degioannis',
  'deleo',
  'delogu',
  'deluca',
  'delussu',
  'demarchi',
  'demarco',
  'demaria',
  'demarinis',
  'demartino',
  'demartis',
  'demontis',
  'demuro',
  'demurtas',
  'demuru',
  'denurra',
  'depalmas',
  'depaolis',
  'deplano',
  'deroma',
  'derosas',
  'devito',
  'deagostini',
  'deana',
  'debertolo',
  'debidda',
  'decandia',
  'deciola',
  'decortes',
  'dedola',
  'dedoni',
  'deffraia',
  'defraia',
  'degioannis',
  'degliesposti',
  'degortes',
  'deiana',
  'deias',
  'deidda',
  'deiola',
  'dejana',
  'delbianco',
  'delprete',
  'delrio',
  'deledda',
  'delfino',
  'delfiore',
  'deligia',
  'deliperi',
  'delirio',
  'delitala',
  'dellamaria',
  'dellarocca',
  "dell'apa",
  'dellipaoli',
  "dell'orfano",
  'delogu',
  'delponte',
  'delrio',
  'delugas',
  'delunas',
  'delussu',
  'demarchi',
  'demartino',
  'demartis',
  'demela',
  'demelas',
  'demofonti',
  'demontis',
  'demuro',
  'demurtas',
  'demuru',
  'denotti',
  'dente',
  'denti',
  'dentis',
  'denurra',
  'depalmas',
  'depau',
  'deperu',
  'deplano',
  'depperu',
  'deriu',
  'deroma',
  'derosas',
  'desogus',
  'desole',
  'desotgiu',
  'dessalvi',
  'dessena',
  'dessi',
  "dessi'",
  'dessolis',
  'dessupoi',
  'dessupoiu',
  'dessy',
  'destasio',
  'destefanis',
  'destro',
  'detotto',
  'dettori',
  'deturres',
  'devito',
  'devoto',
  'dibernardo',
  'dicarlo',
  'didonato',
  'didonna',
  'difede',
  'digiusto',
  'dimartino',
  'dimauro',
  'dimuro',
  'dipasquale',
  'disanto',
  'disomma',
  'diana',
  'dicesare',
  'didaci',
  'diliberto',
  'dimartino',
  'dispenza',
  'doa',
  'dodero',
  'dolce',
  'dolci',
  'donadio',
  'donaera',
  'doneddu',
  'dore',
  'dorgali',
  'doria',
  'doro',
  'dro',
  "dro'",
  'dudda',
  'dui',
  'dulcis',
  'durante',
  'duras',
  'durzu',
  'ebau',
  'ecca',
  'ellis',
  'ena',
  'enas',
  'ennas',
  'enne',
  'enria',
  'epicureo',
  'erbi',
  "erbi'",
  'erdas',
  'erittu',
  'eriu',
  'erre',
  'erriu',
  'erta',
  'espa',
  'espis',
  'esposito',
  'esu',
  'etzi',
  'etzo',
  'eusebi',
  'evaristo',
  'fa',
  'faa',
  'fabbri',
  'fabris',
  'fabrizio',
  'facchini',
  'fadda',
  'faedda',
  'fagioli',
  'fai',
  'faiella',
  'fais',
  'falchi',
  'falcone',
  'falconi',
  'falqui',
  'fanari',
  'fancello',
  'fancellu',
  'fanni',
  'fanti',
  'fantozzi',
  'fanuntza',
  'fanunza',
  'fanutza',
  'fanzecco',
  'fara',
  'farai',
  'faraone',
  'farci',
  'fares',
  'farina',
  'farinella',
  'farinola',
  'farris',
  'fasoli',
  'fassio',
  'fastame',
  'fatarella',
  'favaretto',
  'favaro',
  'favilla',
  'fede',
  'federici',
  'feduzi',
  'felis',
  'felix',
  'fenu',
  'fenuccio',
  'fenudi',
  'fenza',
  'feola',
  'fercia',
  'ferluga',
  'ferracci',
  'ferrai',
  'ferralis',
  'ferrante',
  'ferrari',
  'ferraro',
  'ferreli',
  'ferreri',
  'ferrero',
  'ferri',
  'ferrini',
  'ferro',
  'ferru',
  'figini',
  'figliola',
  'figoni',
  'figus',
  'filigheddu',
  'filindeu',
  'filippi',
  'fina',
  "fina'",
  'fine',
  'fini',
  'fiocchi',
  'fiore',
  'fioredda',
  'fioretti',
  'fiori',
  'fiorina',
  'firino',
  'firinu',
  'fiumene',
  'flenghi',
  'flore',
  'florenzano',
  'flores',
  'flori',
  'floris',
  'flumene',
  'foca',
  'fochi',
  'foddai',
  'foddanu',
  'fodde',
  'foddi',
  'foddis',
  'foglia',
  'fois',
  'follesa',
  'fonnesu',
  'forma',
  'fornara',
  'fornelli',
  'forresu',
  'forte',
  'forteleoni',
  'fortuna',
  'foschi',
  'fossati',
  'fotzi',
  'fozzi',
  'frailis',
  'franceschini',
  'franco',
  'franzini',
  'franzinu',
  'franzo',
  'frasca',
  'frassetto',
  'fratta',
  'fratus',
  'frau',
  'fresi',
  'fresu',
  'frezza',
  'frigau',
  'frisciata',
  'frizza',
  'frogheri',
  'frongia',
  'fronteddu',
  'frulio',
  'fuccella',
  'fugazza',
  'fulgheri',
  'fundoni',
  'furcas',
  'furesi',
  'fusillo',
  'gabba',
  'gabbas',
  'gabbi',
  'gabriele',
  'gaddari',
  'gaddia',
  'gadoni',
  'gaeta',
  'gaggioli',
  'gai',
  'gaias',
  'galano',
  'galanti',
  'galaresu',
  'galici',
  'galimberti',
  'galistu',
  'galitzia',
  'galleri',
  'galletto',
  'galleu',
  'galliani',
  'galliero',
  'gallino',
  'gallisai',
  'gallistru',
  'gallo',
  'gallozzi',
  'gallus',
  'galozzi',
  'gambella',
  'gamberoni',
  'gambino',
  'gamboni',
  'gambula',
  'ganadu',
  'ganau',
  'gandino',
  'ganga',
  'gangemi',
  'gannau',
  'garau',
  'gareddu',
  'garia',
  'garibaldi',
  'gario',
  'garippa',
  'gasola',
  'gaspa',
  'gastoni',
  'gatti',
  'gatto',
  'gattu',
  'gattus',
  'gattuso',
  'gaviano',
  'gavioli',
  'gemma',
  'gemmi',
  'generoso',
  'genovese',
  'gentile',
  'germani',
  'gervasi',
  'gessa',
  'ghera',
  'ghessa',
  'ghiaccio',
  'ghiani',
  'ghilardi',
  'ghinami',
  'ghio',
  'ghironi',
  'ghisoni',
  'ghisu',
  'giacalone',
  'giacomelli',
  'giagheddu',
  'giagoni',
  'giagu',
  'giannattasio',
  'giannichedda',
  'giannoni',
  'gianoglio',
  'giardina',
  'giau',
  'gigante',
  'giglio',
  'giloni',
  'ginatempo',
  'ginesu',
  'gioia',
  'giongo',
  'giordano',
  'giordi',
  'giordo',
  'giorgetti',
  'giorgi',
  'giorgini',
  'giovannetti',
  'giovannini',
  'giraldi',
  'girau',
  'girotti',
  'giua',
  'giuca',
  'giudice',
  'giunta',
  'giuntini',
  'giusto',
  'gobbi',
  'gobbini',
  'goddi',
  'golosio',
  'gori',
  'gorni',
  'gosamo',
  'gotti',
  'gramsci',
  'granato',
  'granieri',
  'grassi',
  'grasso',
  'grauso',
  'gravellu',
  'graziano',
  'greco',
  'grecu',
  'greggio',
  'gregoriani',
  'gregorio',
  'gregu',
  'griecco',
  'grieco',
  'grifoni',
  'grillo',
  'grimal',
  'grimaldi',
  'grina',
  'grisoni',
  'grixoni',
  'gromme',
  'grosso',
  'grussu',
  'guadagni',
  'guadagnini',
  'gualandi',
  'guarducci',
  'guddelmoni',
  'gudelmoni',
  'guerra',
  'guido',
  'guiso',
  'guisu',
  'gungui',
  'guria',
  'gusai',
  'gusinu',
  'guzzi',
  'iacono',
  'iai',
  'ibba',
  'idda',
  'iddas',
  'idili',
  'idini',
  'imbesi',
  'impera',
  'imperiali',
  'imprugas',
  'incani',
  'incollu',
  'inconi',
  'incrisse',
  'ingrao',
  'intelisano',
  'inzaina',
  'irasci',
  'irde',
  'isola',
  'isoni',
  'isu',
  'italiano',
  'lamantia',
  'lamarca',
  'lamonica',
  'larosa',
  'labieni',
  'laconi',
  'ladoni',
  'ladu',
  'lai',
  'laino',
  'lallai',
  'lamantia',
  'lambroni',
  'lampis',
  'lanata',
  'langasco',
  'langiu',
  'lanza',
  'lasi',
  'lasio',
  'latte',
  'latu',
  'lau',
  'lavra',
  'lazzari',
  'lazzaro',
  'leandri',
  'lecca',
  'leccis',
  'lecis',
  'ledda',
  'leggieri',
  'leggio',
  'leinardi',
  'lella',
  'leo',
  'leonardi',
  'leone',
  'leoni',
  'lepori',
  'lesca',
  'lezzeri',
  'libera',
  'licheri',
  'ligas',
  'ligios',
  'lilliu',
  'lillu',
  'limbardi',
  'limiti',
  'lindiri',
  'lintas',
  'linzas',
  'lioni',
  'liori',
  'lippi',
  'lisai',
  'lisca',
  'lisci',
  'liscia',
  'lisi',
  'lissia',
  'littarru',
  'littera',
  'livesi',
  'lixi',
  'lixia',
  'lizzeri',
  'lo',
  'logiacco',
  'losardo',
  'lobina',
  'locche',
  'locci',
  'loche',
  'lodde',
  'loddo',
  'loi',
  'lolliri',
  'lombardi',
  'longheu',
  'longo',
  'longobucco',
  'longu',
  'loni',
  'lonis',
  'lorelli',
  'lorenzo',
  'lorenzoni',
  'loria',
  'loriga',
  'lorrai',
  'loru',
  'lostia',
  'lotta',
  'lotto',
  'loy',
  'lubrano',
  'lucarelli',
  'lucca',
  'lucchesu',
  'lucchette',
  'luciano',
  'lucini',
  'lugas',
  'luiu',
  'lulleri',
  'lullia',
  'lulliri',
  'lunesu',
  'lupetti',
  'lupinu',
  'lusci',
  'lusso',
  'lussu',
  'lutzu',
  'luxi',
  'luzi',
  'luzzu',
  'macaluso',
  "maccio'",
  'macciocco',
  'macciocu',
  'maccioni',
  'macciotta',
  'maccotta',
  'maciocco',
  'macis',
  'madau',
  'madeddu',
  'madori',
  'madrau',
  'maestrale',
  'maffei',
  'maffi',
  'magari',
  'maggi',
  'maggio',
  'maggiolo',
  'maggioni',
  'maggiulli',
  'magni',
  'magri',
  'magro',
  'maguledda',
  'maiale',
  'maieli',
  'mainas',
  'maiorana',
  'maiorano',
  'maiorca',
  'maiu',
  'malatesta',
  'maldini',
  'malduca',
  'malicca',
  'mallai',
  'mallao',
  'mallica',
  "mallo'",
  'mallus',
  'maltana',
  'maltese',
  'malu',
  'maludrottu',
  'mameli',
  'mammoliti',
  'mamusa',
  'mana',
  'manai',
  'manca',
  'mancadinissa',
  'manchinu',
  'mancini',
  'mancinone',
  'manco',
  'manconi',
  'mancosu',
  'mancuso',
  'mandas',
  'mandibola',
  'mandis',
  'mandras',
  'manetti',
  'manghina',
  'manghini',
  'mangiardi',
  'mangione',
  'mangone',
  'mangoni',
  'manias',
  'manis',
  'maniscalco',
  'manna',
  'mannai',
  'mannia',
  'mannino',
  'mannis',
  'manno',
  'mannoni',
  'mannu',
  'mannurita',
  'manos',
  'mantega',
  'mantovani',
  'manunta',
  'manunza',
  'manus',
  'manzo',
  'manzottu',
  'manzu',
  'maoddi',
  'mapelli',
  'mara',
  'maran',
  'marangoni',
  'marca',
  'marceddu',
  'marcellino',
  'marcello',
  'marche',
  'marchesi',
  'marchesini',
  'marchi',
  'marchioni',
  'marci',
  'marcia',
  'marcialis',
  'marcias',
  'marcis',
  'marcomin',
  'marello',
  'maresu',
  'marfia',
  'margagliotti',
  'marghinesu',
  'marghinotti',
  'marginesu',
  'margini',
  'margiotta',
  'maria',
  'mariane',
  'mariani',
  'mariano',
  'marigosu',
  'marinaro',
  'marini',
  'marino',
  'mariotti',
  'marogna',
  'marongiu',
  'marotta',
  'marotto',
  'marra',
  'marras',
  'marrazzu',
  'marredda',
  'marroccu',
  'marrocu',
  'marrone',
  'marroni',
  'marrosu',
  'marruncheddu',
  'porra',
  'marsala',
  'marteddu',
  'martelli',
  'marti',
  'martinelli',
  'martinez',
  'martini',
  'martiradonna',
  'martiri',
  'martis',
  'martucci',
  'marzi',
  'marzo',
  'masala',
  'maschio',
  'masci',
  'mascia',
  'masia',
  'masili',
  'masini',
  'masinielli',
  'masone',
  'masones',
  'massa',
  'massacci',
  'massaro',
  'massidda',
  'mastino',
  'mastinu',
  'mastio',
  'masu',
  'materazzo',
  'matta',
  'mattana',
  'matteoli',
  'mattesu',
  'mattu',
  'matzeu',
  'maulu',
  'maxia',
  'mazza',
  'mazzei',
  'mazziotti',
  'mazzitta',
  'mazzone',
  'mazzoni',
  'mazzucchelli',
  'mazzuzi',
  'me',
  'meaggia',
  'medas',
  'medda',
  'medde',
  'mei',
  'meier',
  'mela',
  'melafontana',
  'melani',
  'mele',
  'meledina',
  'meles',
  'meli',
  'melis',
  'mellini',
  'mellino',
  'melone',
  'meloni',
  'melosu',
  'menga',
  'meo',
  'mercurio',
  'mercuriu',
  'merella',
  'mereu',
  'mesina',
  'messaggi',
  'messina',
  'mette',
  'meucci',
  'michele',
  'michieli',
  'migheli',
  'milanese',
  'milano',
  'milia',
  'milo',
  'minelli',
  'mingioni',
  'mingoia',
  'minnai',
  'minniti',
  'miotti',
  'miraglia',
  'mirto',
  'miscali',
  'mocci',
  'modolo',
  'moi',
  'moica',
  'molinas',
  'molinu',
  'molla',
  'monagheddu',
  'mongili',
  'mongittu',
  'moni',
  'monne',
  'monni',
  'montalbano',
  'montaldo',
  'monte',
  'montesano',
  'montesu',
  'montevecchi',
  'monti',
  'montis',
  'montisci',
  'montixi',
  'mora',
  'morabito',
  'morandi',
  'morelli',
  'morero',
  'moretti',
  'moriconi',
  'morittu',
  'mormile',
  'moro',
  'moroni',
  'morra',
  'moschella',
  'mossa',
  'mosso',
  'mostallino',
  'motta',
  'motzo',
  'mozzo',
  'mu',
  'mua',
  'mucelli',
  'mudu',
  'muggiano',
  'muggianu',
  'muggironi',
  'muggittu',
  'mugheddu',
  'muglia',
  'mugone',
  'mula',
  'mulana',
  'mulargia',
  'mulas',
  'mullano',
  'muller',
  'mulleri',
  'mulliri',
  'multineddu',
  'mundula',
  'muntoni',
  'mura',
  'muras',
  'muratore',
  'murdeu',
  'mureddu',
  'murenu',
  'muretti',
  'murgia',
  'murgioni',
  'murineddu',
  'murino',
  'muroni',
  'murrali',
  'murranca',
  'murredda',
  'murreddu',
  'murroccu',
  'murroni',
  'murru',
  'murtas',
  'muru',
  'musa',
  'muscas',
  'musinu',
  'musio',
  'musiu',
  'musselli',
  'mussi',
  'mustacciu',
  'mustaro',
  'mustazzu',
  'musu',
  'mutzette',
  'mutzu',
  'muzzoni',
  'muzzu',
  'nairi',
  'naitana',
  'naitza',
  'nalli',
  'nannarelli',
  'nanni',
  'nanu',
  'napoleone',
  'napoli',
  'narciso',
  'nardo',
  'nasone',
  'nateri',
  'nati',
  'natoli',
  'nela',
  'neri',
  'nero',
  'nesti',
  'nicchiri',
  'niccolai',
  'nico',
  'nicolai',
  'niedda',
  'nieddu',
  'nioi',
  'niola',
  'nobile',
  'nocco',
  'noga',
  'noli',
  'nonis',
  'nonne',
  'nonnis',
  'nossardi',
  'nova',
  'nufris',
  'nughedu',
  'nurchi',
  'nurchis',
  'nurra',
  'nuvoli',
  'obino',
  'obinu',
  'occhineri',
  'occhioni',
  'oddo',
  'odoni',
  'ogana',
  'oggiano',
  'oggianu',
  'ogno',
  'oleda',
  'olia',
  'olianas',
  'oliva',
  'olivero',
  'olivieri',
  'olla',
  'ollargiu',
  'olmeo',
  'olmetto',
  'onali',
  'onano',
  'onida',
  'onidi',
  'onnis',
  'ono',
  'oppes',
  'oppo',
  'orani',
  'orano',
  'orecchioni',
  'orgiano',
  'orgiu',
  'oriani',
  'orlandi',
  'orlando',
  'ornano',
  'oro',
  'orri',
  'orro',
  'orru',
  "orru'",
  'ortelli',
  'ortolani',
  'ortu',
  'orunesu',
  'osilo',
  'ossola',
  'ottini',
  'pace',
  'pacelli',
  'pacini',
  'paddeu',
  'padedda',
  'paderas',
  'paderi',
  'padiglia',
  'pagani',
  'paggiolu',
  'paglietti',
  'pagni',
  'pais',
  'pala',
  'palau',
  'palermo',
  'palimodde',
  'palitta',
  'palla',
  'palmas',
  'palmieri',
  'palmiotto',
  'palmisano',
  'palomba',
  'palumbo',
  'panai',
  'panduccio',
  'pani',
  'panico',
  'pannella',
  'panniello',
  'panzalis',
  'paolini',
  'paolucci',
  'paone',
  'papa',
  'papandrea',
  'papi',
  'paracchini',
  'parada',
  'parco',
  'parisi',
  'parodi',
  'parrella',
  'parziale',
  'pascai',
  'pascarella',
  'paschina',
  'paschino',
  'pasci',
  'pasella',
  'pasini',
  'pasquini',
  'pasquino',
  'passaghe',
  'passalacqua',
  "passero'",
  'passeroni',
  'passino',
  'pastore',
  'pastorelli',
  'pastorino',
  'patania',
  'pateri',
  'patrizio',
  'patta',
  'patteri',
  'pattusi',
  'pau',
  'paulis',
  'pavan',
  'pedde',
  'peddio',
  'peddis',
  'pedditzi',
  'peddoni',
  'pedduzza',
  'pedroni',
  'pegoraro',
  'peis',
  'pellegrini',
  'pellegrino',
  'pellerano',
  'pellicciari',
  'peloso',
  'peluffo',
  'peluso',
  'penco',
  'pene',
  'penna',
  'pera',
  'peralta',
  'perandria',
  'perdixi',
  'perella',
  'pericu',
  'perillo',
  'perino',
  'perna',
  'pernarella',
  'peronnia',
  'perotto',
  'perra',
  'perras',
  'perria',
  'perricone',
  'perrone',
  'perseu',
  'persico',
  'peru',
  'peruzzi',
  'peruzzu',
  'pes',
  'petretto',
  'petrini',
  'petta',
  'pettosini',
  'petza',
  'pezzi',
  'pia',
  'piana',
  'piano',
  'pianta',
  'pianti',
  'pianu',
  'pias',
  'pibi',
  'pibia',
  'pibiri',
  'picasso',
  'piccaluga',
  'piccardi',
  'picchedda',
  'picchereddu',
  'picci',
  'picciau',
  'piccioni',
  'picconi',
  'piccu',
  'pichereddu',
  'picone',
  'picus',
  'piddiu',
  'piedimonte',
  'pieroni',
  'piga',
  'pigheddu',
  'pilato',
  'pileri',
  'pili',
  'pilia',
  'pilialvu',
  'pilicchi',
  'pilisi',
  'pilittu',
  'pillai',
  'pilleri',
  'pillittu',
  'pillitu',
  'pillolla',
  'pillonca',
  'pilloni',
  'pillosu',
  'pilludu',
  'pilo',
  'piloni',
  'pilosu',
  'pilu',
  'piludu',
  'pilurzi',
  'pilutza',
  'pinciroli',
  'pinducciu',
  'pinna',
  'pino',
  'pintadu',
  'pinto',
  'pintor',
  'pintore',
  'pintori',
  'pintus',
  'pio',
  'piombo',
  'pioncu',
  'piotti',
  'pipere',
  'pipia',
  'pippa',
  'pippia',
  'piquereddu',
  'pira',
  'pirarba',
  'piras',
  'pirastru',
  'pirastu',
  'piredda',
  'pireddu',
  'pirella',
  'pirellas',
  'piretto',
  'piria',
  'pirillo',
  'pirina',
  'pirino',
  'pirinu',
  'pirisi',
  'pirisino',
  'pirisinu',
  'pirlo',
  'piro',
  'pirodda',
  'piroddi',
  'piroi',
  'pirola',
  'pirosu',
  'pirrello',
  'pirri',
  'pirriano',
  'pisani',
  'pisano',
  'pisanu',
  'piscedda',
  'pischedda',
  'pisciottu',
  'piscitelli',
  'piseddu',
  'pisoni',
  'pistidda',
  'pistis',
  'pisu',
  'pisuttu',
  'pitalis',
  'pittalis',
  'pittau',
  'pittoni',
  'pittorra',
  'pitturru',
  'pitzalis',
  'pitzanti',
  'pitzianti',
  'pitzolo',
  'pitzolu',
  'pitzus',
  'piu',
  'pizzadili',
  'pizzu',
  'podda',
  'poddesu',
  'poddi',
  'poddie',
  'poddighe',
  'poddine',
  'poggi',
  'poledda',
  'poli',
  'polimene',
  'polo',
  'polverini',
  'pomata',
  'pompa',
  'ponga',
  'poni',
  'ponsano',
  'ponti',
  'pontillo',
  'porcedda',
  'porceddu',
  'porcella',
  'porcheddu',
  'porcina',
  'porcu',
  'porfilio',
  'porqueddu',
  'porricino',
  'porru',
  'porta',
  'portas',
  'portoghese',
  'posadino',
  'posadinu',
  'postiglione',
  'potettu',
  'pozzato',
  'prandi',
  'pranteddu',
  'pretta',
  'previti',
  'prevosto',
  'princiotta',
  'prinzis',
  'priori',
  'proietti',
  'provenzano',
  'pruna',
  'prunas',
  'pruneddu',
  'pudda',
  'puddino',
  'puddinu',
  'puddu',
  'puggioni',
  'pugioni',
  'puledda',
  'puliga',
  'puligheddu',
  'pulina',
  'pulisci',
  'pulixi',
  'puncioni',
  'pupillo',
  'purcheddu',
  'purcu',
  'pusceddu',
  'pusole',
  'putzolu',
  'putzu',
  'putzulu',
  'puxeddu',
  'puzzu',
  'rabissoni',
  'raccimolo',
  'raccis',
  'racis',
  'raga',
  'ragatzu',
  'ragnedda',
  'raimondi',
  'rais',
  'ranieri',
  'rapisarda',
  'raspa',
  'raspi',
  'raspino',
  'raspitzu',
  'raspizzu',
  'rassu',
  'ratto',
  'rau',
  'ravera',
  're',
  'reale',
  'redaelli',
  'regaldo',
  'remerciaro',
  'renga',
  'renis',
  'renzo',
  'repetto',
  'rescaldani',
  'riani',
  'ribichesu',
  'ricci',
  'ricciardi',
  'riccio',
  'ridolfini',
  'riguer',
  'rinaldi',
  'rinaldo',
  'rinner',
  'riu',
  'riva',
  'rivano',
  'rivella',
  'rivera',
  'rivieccio',
  'rizzardini',
  'rizzi',
  'rizzo',
  'rizzu',
  'robinson',
  'rocca',
  'rocco',
  'rodriguez',
  'roich',
  'rolesu',
  'roma',
  'romagna',
  'romano',
  'rombi',
  'romeo',
  'romero',
  'ros',
  'rosa',
  'rosas',
  'rosati',
  'roscioli',
  'rosiello',
  'rossetti',
  'rossi',
  'rosso',
  'rosu',
  'rotilio',
  'rotondi',
  'rovandi',
  'roych',
  'rozzo',
  'rozzu',
  'rubatta',
  'rubattu',
  'rubini',
  'rubino',
  'rubiu',
  'ruda',
  'rudas',
  'ruggeri',
  'ruggero',
  'ruggiero',
  'ruggiu',
  'ruiu',
  'ruju',
  'rumiz',
  'rundeddu',
  'rusconi',
  'russino',
  'russo',
  'russu',
  'ruzzittu',
  'ruzzo',
  'ruzzu',
  'saba',
  'sabatini',
  'sabeddu',
  'sabino',
  'sabiu',
  'saccu',
  'saddi',
  'saderi',
  'sagheddu',
  'sagoni',
  'sai',
  'saias',
  'sailis',
  'sais',
  'saiu',
  'sala',
  'salaris',
  'salazar',
  'sale',
  'salemi',
  'salici',
  'salidu',
  'salina',
  'salis',
  'salonis',
  'salvatore',
  'salvucci',
  'sanciu',
  'sandoli',
  'sandri',
  'sanna',
  'sanneris',
  'sannia',
  'sannio',
  'sanniu',
  'santi',
  'santona',
  'santoni',
  'santonocito',
  'santoro',
  'santoru',
  'santucci',
  'santus',
  'saponara',
  'saporito',
  'saporitu',
  'sappino',
  'sarais',
  'sardegna',
  'sardi',
  'sardo',
  'sardu',
  'sarigu',
  'sarobba',
  'sarritzu',
  'sartor',
  'sartori',
  'sassi',
  'sasso',
  'sassu',
  'satgia',
  'satta',
  'sattanino',
  'sau',
  'savona',
  'sbressa',
  'scaglione',
  'scala',
  'scalas',
  'scampuddu',
  'scano',
  'scanu',
  'scardaccio',
  'scarpa',
  'scattu',
  'scema',
  'schembri',
  'schiaffino',
  'schiavone',
  'schintu',
  'schirra',
  'schirru',
  'schumacher',
  'scialpi',
  'sciarra',
  'scintu',
  'sciola',
  'scioni',
  'scipioni',
  'sciuto',
  'scocci',
  'scodina',
  'scognamiglio',
  'scognamillo',
  'scotti',
  'scottu',
  'scrugli',
  'scuderi',
  'scudu',
  'scugugia',
  'scuto',
  'sebis',
  'secchi',
  'secci',
  'sechi',
  'seci',
  'secondi',
  'sedda',
  'seddaiu',
  'seddone',
  'sega',
  'segni',
  'selenu',
  'selis',
  'sella',
  'selloni',
  'semprevisto',
  'sena',
  'senes',
  'senis',
  'senserini',
  'sequi',
  'serafini',
  'serafino',
  'serci',
  'serdino',
  'sergi',
  'serini',
  'serpi',
  'serpollo',
  'serra',
  'serramanzu',
  'serrao',
  'serrau',
  'serreli',
  'serrenti',
  'serreri',
  'serri',
  'serru',
  'serusi',
  'serventi',
  'sestu',
  'sesuru',
  'sette',
  'settimi',
  'setzu',
  'seu',
  'sforza',
  'sias',
  'siccardo',
  'siccu',
  'siciliano',
  'sida',
  'siddi',
  'siddu',
  'sieni',
  'sifredi',
  'silanos',
  'silanus',
  'silva',
  'silvestri',
  'silvia',
  'simbula',
  'simeone',
  'simola',
  'simoncini',
  'simone',
  'simula',
  'sini',
  'sinis',
  'sinopoli',
  'sio',
  'siotto',
  'sircana',
  'sirigu',
  'siriu',
  'sisini',
  'sisti',
  'sistu',
  'sitzia',
  'siuni',
  'soddu',
  'soggia',
  'soggiu',
  'soi',
  'sois',
  'solanas',
  'soletta',
  'soliani',
  'solinas',
  'solla',
  'sollai',
  'sonedda',
  'sonis',
  'sonnu',
  'sorba',
  'soriga',
  'soro',
  'sorrentino',
  'soru',
  'sotgia',
  'sotgiu',
  'spada',
  'spagnoli',
  'spanedda',
  'spano',
  "spano'",
  'spanu',
  'spatafora',
  'speranza',
  'speroni',
  'spiga',
  'spina',
  'spinas',
  'spinella',
  'spinetti',
  'spinosu',
  'spissu',
  'sposito',
  'staiano',
  'stangoni',
  'stara',
  'starace',
  'statzu',
  'stazzu',
  'steri',
  'stocchino',
  'stochino',
  'stoppa',
  'stori',
  'stradoni',
  'strazzera',
  'strazzeri',
  'streddi',
  'strozzi',
  'struvaldi',
  'stucchi',
  'succa',
  'succu',
  'suella',
  'suergiu',
  'sulas',
  'sulcis',
  'sulis',
  'summa',
  'sunda',
  'sundas',
  'sunis',
  'sunk',
  'supino',
  'tacchi',
  'tacconi',
  'taccori',
  'taddei',
  'tagliabue',
  'tagliaferro',
  'tali',
  'tallis',
  'talloru',
  'tallu',
  'tambasco',
  'tamponi',
  'tanas',
  'tanca',
  'tanchis',
  'tanda',
  'tandeddu',
  'tangianu',
  'tani',
  'tanzi',
  'tarantini',
  'taras',
  'taris',
  'tassotti',
  'tatti',
  'tavolacci',
  'taylor',
  'tedde',
  'tedesco',
  'tegas',
  'tempesta',
  'tenardi',
  'tendas',
  'terebinto',
  'terrazzoni',
  'terrone',
  'terrosu',
  'testa',
  'testoni',
  'tiana',
  'ticca',
  'tiddia',
  'tidili',
  'tidu',
  'tilloca',
  'tillocca',
  'tiloca',
  'tilocca',
  'tinari',
  'tinteri',
  'tinti',
  'tintis',
  'tirini',
  'tivinio',
  'tocca',
  'tocco',
  'toccu',
  'todde',
  'todesco',
  'tola',
  'tolu',
  'tomasello',
  'tomasi',
  'tonino',
  'tonzanu',
  'tore',
  'tornatore',
  'toro',
  'torricelli',
  'toscano',
  'tosciri',
  'tosi',
  'totti',
  'toxiri',
  'tozzi',
  'tramaloni',
  'tranza',
  'trapani',
  'trastu',
  'trastus',
  'tratzi',
  'trevisan',
  'trincas',
  'trinchero',
  'triscritti',
  'troga',
  'trogu',
  'troia',
  'troiani',
  'tronci',
  'troncia',
  'trova',
  'truddaiu',
  'trudu',
  'trullu',
  'truzzu',
  'tuccio',
  'tucconi',
  'tufano',
  'tugulu',
  'tulli',
  'tupponi',
  'tura',
  'turco',
  'turis',
  'turno',
  'turri',
  'turris',
  'tuveri',
  'uccheddu',
  'uccula',
  'ucheddu',
  'uda',
  'ugas',
  'ugnutu',
  'ulargiu',
  'uleri',
  'ulgheri',
  'ullasci',
  'ulleri',
  'ulzega',
  'umana',
  'unali',
  'uneddu',
  'unida',
  'uras',
  'urciuolo',
  'urgu',
  'urigu',
  'uroni',
  'urpi',
  'urpis',
  'urracci',
  'urraci',
  'urrai',
  'urru',
  'usai',
  'usala',
  'uscidda',
  'uselli',
  'useri',
  'usula',
  'utzeri',
  'vacca',
  'vaccargiu',
  'vaccari',
  'vacquer',
  'vadilonga',
  'valdes',
  'valentini',
  'vallascas',
  'vallieri',
  'vanni',
  'vannini',
  'vaquer',
  'vardeu',
  'varese',
  'vargiolu',
  'vargiu',
  'varsi',
  'vasselli',
  'vecchione',
  'vecere',
  'vellante',
  'vento',
  'ventroni',
  'ventura',
  'venturi',
  'veracchi',
  'verano',
  'veranu',
  'verde',
  'verderosa',
  'verdi',
  'verga',
  'vernaleone',
  'vessillo',
  'vettori',
  'vezzoli',
  'viale',
  'vicari',
  'vidini',
  'viglino',
  'villaminar',
  'vinci',
  'vincis',
  'viola',
  'virdis',
  "virdo'",
  'vistosu',
  'vitale',
  'vitiello',
  'vitzizai',
  'vitzizzai',
  'vivarelli',
  'vizzari',
  'volpe',
  'volpi',
  'volti',
  'zaccaria',
  'zaccheddu',
  'zacchera',
  'zacheddu',
  'zaffarano',
  'zaffiro',
  'zagaria',
  'zago',
  'zamburru',
  'zanatta',
  'zanda',
  'zandara',
  'zanetti',
  'zanni',
  'zappu',
  'zara',
  'zaru',
  'zazzara',
  'zedda',
  'zedde',
  'zerbino',
  'zicchi',
  'zichi',
  'zidda',
  'zimperi',
  'zinchiri',
  'zini',
  'zirano',
  'ziranu',
  'zireddu',
  'ziri',
  'zirolia',
  'zirone',
  'zirulia',
  'ziulu',
  'zoa',
  'zobba',
  'zoccheddu',
  'zoeddu',
  'zola',
  'zonca',
  'zoncheddu',
  'zonchello',
  'zonza',
  'zori',
  'zoroddu',
  'zorzi',
  'zou',
  'zucca',
  'zucconi',
  'zuddas',
  'zuffi',
  'zuncheddu',
  'zunnui',
  'zurru',
  'zurzolo',
];

export default surnames;
